const getters = {
  transaction(state) {
    return state.transaction;
  },
  transactions(state) {
    return state.transactions;
  },
};

export default getters;
